import ExpoConstants from 'expo-constants';
import { EASConfig } from 'expo/config';
import { Platform } from 'react-native';

import type { JoinstarConfig } from '../app.config';

function getConstants() {
  const expoConfig = ExpoConstants.expoConfig;
  if (!expoConfig?.extra) {
    throw new Error('Expo config is required to initialize constants.');
  }

  return {
    joinstar: expoConfig.extra.joinstar as JoinstarConfig,
    owner: expoConfig.owner,
    slug: expoConfig.slug,
    version: expoConfig.version,
    scheme: expoConfig.scheme,
    buildVersion: Platform.select<string | number | undefined>({
      default: undefined,
      ios: expoConfig.ios?.buildNumber,
      android: expoConfig.android?.versionCode,
    }),
    eas: expoConfig.extra.eas as EASConfig,
  };
}

const Constants = getConstants();

export default Constants;

export function isProd() {
  return Constants.joinstar.JSENV === 'prod';
}

export function isDev() {
  return Constants.joinstar.DEV;
}

export function getVersionText() {
  return 'v' + Constants.version + (Constants.buildVersion ? ` (${Constants.buildVersion})` : '');
}

export const SHARE_MESSAGE =
  `Hey! Sharing an invite to Joinstar - ` +
  `an invite-only app for meeting up with friends ` +
  `when traveling. Joinstar connects you with your ` +
  `friends who are also planning to be in the cities ` +
  `you are heading to. I selfishly need you on the app ` +
  `so I can keep up with your travels! Just a note that ` +
  `this invite expires in 24 hours. Excited to see you there! ` +
  `Check it out at ${Constants.joinstar.company.links.landing}.`;
